import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path d="m9.05 2.218 4.625 4.333A.91.91 0 0 1 14 7.25v6.874c0 .504-.41.913-.917.913H3.917A.914.914 0 0 1 3 14.123V7.25a.91.91 0 0 1 .325-.698L7.95 2.218a.92.92 0 0 1 1.1 0Z"></path><path fill-rule="evenodd" d="M28.675 6.551 24.05 2.218a.92.92 0 0 0-1.1 0l-4.625 4.333A.91.91 0 0 0 18 7.25v6.874c0 .504.41.913.917.913h9.166a.914.914 0 0 0 .917-.913V7.25a.91.91 0 0 0-.325-.698ZM23.5 4.444l3.5 3.28v5.312h-7V7.723l3.5-3.28Z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="m9.05 17.218 4.625 4.333a.91.91 0 0 1 .325.698v6.874c0 .504-.41.913-.917.913H3.917A.914.914 0 0 1 3 29.123V22.25a.91.91 0 0 1 .325-.698l4.625-4.333a.92.92 0 0 1 1.1 0ZM12 22.723l-3.5-3.28-3.5 3.28v5.313h7v-5.313Z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="m28.675 21.551-4.625-4.333a.92.92 0 0 0-1.1 0l-4.625 4.333a.91.91 0 0 0-.325.698v6.874c0 .504.41.913.917.913h9.166a.914.914 0 0 0 .917-.913V22.25a.91.91 0 0 0-.325-.698ZM23.5 19.444l3.5 3.28v5.312h-7v-5.313l3.5-3.28Z" clip-rule="evenodd"></path></g>';
export var HomeSimilarOutlineSVG = function HomeSimilarOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
HomeSimilarOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(HomeSimilarOutlineSVG);